module.exports = __webpack_public_path__ + "static/media/deliveryVan_blue.6199cbb3.svg";